import { ComponentType, EventTypes } from "../../data";
export const ComponentTypeMapper = {
    [EventTypes.Fixture]: (isMiniCard) => getFixtureType(isMiniCard),
    [EventTypes.Outright]: (isMiniCard, isLive) => getOutrightType(isLive, isMiniCard),
    [EventTypes.AggregateFixture]: (isMiniCard) => ComponentType.AggregateCard
};
const getFixtureType = (isMiniCard) => {
    return isMiniCard
        ? ComponentType.MiniEventCard
        : ComponentType.EventCard;
};
const getOutrightType = (eventIsLive, isMiniCard) => {
    if (!eventIsLive) {
        return ComponentType.PreliveOutright;
    }
    return isMiniCard
        ? ComponentType.MiniLiveOutright
        : ComponentType.LiveOutright;
};
//# sourceMappingURL=ComponentTypeMapper.js.map